module.exports = __webpack_public_path__ + "img/drophistory.1e19c3aa.png";